
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import store from '@/store';
import { Getter } from 'vuex-class';
import { Image, ImageMonth } from '@/types/image';
import ImageUploader from '@/components/Editor/ImageUploader.vue';
import ImageContainer from '@/components/ImageManager/ImageContainer.vue';

@Component({
  components: { ImageUploader, ImageContainer },
})
export default class FeaturedImage extends Vue {
  @Prop() image!: Image;
  @Prop() description!: string | null;
  @Getter('images/images') images!: Image[];
  @Getter('images/imageMonths') imageMonths!: ImageMonth[];

  showError: boolean = false;
  showUploader: boolean = false;
  galleryDialog: boolean = false;

  get imageDescription() {
    return this.description;
  }

  set imageDescription(value) {
    this.$emit('change-description', value);
  }

  get imageExists(): boolean {
    return this.image !== null;
  }

  get imageUrl(): string {
    if (!this.imageExists) return '';

    if (this.image.path.startsWith('http')) {
      return this.image.path;
    }

    return `https://cdn.alternativebusinessfunding.co.uk/530x193/smart/${
      this.image.path
    }`;
  }

  onImageSelected(image: Image) {
    this.$emit('change', image);
    this.galleryDialog = false;
    this.showError = false;
  }

  validate(showErrors: boolean = false) {
    if (showErrors && this.imageExists === false) {
      this.showError = true;
    }
    return this.imageExists;
  }

  mounted() {
    if (this.images.length < 1) {
      const page = 1;
      store.dispatch('images/getPage', { page });
      store.dispatch('images/getImageMonths');
    }
  }
}
